import { pb } from '@/utils/pocketbase';
import * as Algorithm from './algorithm';
import * as Storage from './storage';
import * as Job from './job';

/**
 * Account 模块：处理身份验证与基于 'runs' 表的统计
 */
const Account = {
    // --- 身份验证 ---
    async login({ identity, password }) {
        return await pb.collection('users').authWithPassword(identity, password);
    },

    logout() {
        pb.authStore.clear();
    },

    isAuthenticated() {
        return pb.authStore.isValid;
    },

    async refresh() {
        if (pb.authStore.isValid) {
            return await pb.collection('users').authRefresh();
        }
    },

    getUser() {
        return pb.authStore.model;
    },

    async getUserInfo() {
        return {
            code: pb.authStore.isValid ? 200 : 401,
            data: pb.authStore.model
        };
    },

    // --- 业务统计 (适配 runs 表) ---
    /**
     * 获取首页统计数据
     * 根据 runs 表的状态字段统计：Succeeded (完成), Running (运行中)
     */
    async homeDatas() {
        try {
            // 定义内部辅助函数，禁用自动取消并增加错误容错
            const fetchCount = async (collectionName, filter = '') => {
                try {
                    const res = await pb.collection(collectionName).getList(1, 1, {
                        filter: filter,
                        requestKey: null // 必须设为 null，防止 Promise.all 并发时相互取消
                    });
                    return res.totalItems;
                } catch (e) {
                    console.warn(`Stat fetch for "${collectionName}" (${filter}) failed:`, e.message);
                    return 0;
                }
            };

            // 使用并发请求获取 runs 表和 users 表的数据
            // 注意：这里的 status 值需与你 PocketBase 中 'runs' 表 select 选项的值完全一致
            const [runnerCount, userCount, runningCount] = await Promise.all([
                fetchCount('runs', 'status = "Succeeded"'), // 已完成的任务数
                fetchCount('users'),                        // 注册研究员总数
                fetchCount('runs', 'status = "Running"')    // 正在运行的任务数
            ]);

            return {
                code: 0,
                data: {
                    runnerCount: runnerCount || 0,
                    userCount: userCount || 0,
                    runningCount: runningCount || 0
                }
            };
        } catch (err) {
            console.error("Critical error in homeDatas:", err);
            return {
                code: 0,
                data: { runnerCount: 0, userCount: 0, runningCount: 0 }
            };
        }
    }
};

export {
    Account,
    Algorithm,
    Storage,
    Job
};